// ============================================
// Google AdWords Uzmanı - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const googleAdwordsUzmaniContent: BlogContent = {
  tableOfContents: [
    { id: "uzman-kimdir", title: "Google AdWords Uzmanı Kimdir?" },
    { id: "sertifikalar", title: "Sertifikalar ve Doğrulama" },
    { id: "deneyim-dogrulama", title: "Deneyim Doğrulama" },
    { id: "maliyet-analizi", title: "Maliyet Analizi" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>Google AdWords uzmanı</strong> seçimi, sertifika doğrulama ve deneyim kriterleri."
    }
  ]
};

export default googleAdwordsUzmaniContent;
